import { loadToken } from "./localStorage";
import config from "../config";
import { readLang } from "./languages";

const prepareHeader = options => {
  // options token, json, image?
  let header = config.headers;

  if (typeof options !== "undefined") {
    if (typeof options.json !== "undefined") {
      header["Content-Type"] = "application/json";
    }
    if (typeof options.upload !== "undefined") {
      header["Content-Type"] = "multipart/form-data";
    }
    if (typeof options.token !== "undefined") {
      header.token = loadToken();
    }
  }

  header.langid = readLang();

  return header;
};

export { prepareHeader };
